import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { CommandContentEffects } from './command-content.effects';
import { commandContentFeatureKey, commandContentReducer } from './command-content.reducer';

export const provideCommandContentStore = () => [
  provideState(commandContentFeatureKey, commandContentReducer),
  provideEffects([CommandContentEffects]),
];
